import { useLoaderData, useOutletContext, useParams } from "react-router-dom";

import LoanTimelineTab from "../../../unified-dashboard/src/pages/LoanTimeline";
import { LoanApplicationService } from "../../services/LoanApplication";
import GetAuthContext from "../../shared/context/AuthContext";
import type { CustomLoaderFunctionArgs } from "../../shared/router/RouteLoader";

export async function loanTimelineLoader({
  getToken,
  params,
  pageName
}: CustomLoaderFunctionArgs) {
  const { loanID } = params;

  return await LoanApplicationService.getLoanActivity({
    loanApplicationID: loanID!,
    token: getToken(),
    pageName: pageName!,
    page: 1
  });
}

function LoanTimeline({ pageName }: { pageName?: string }) {
  const { loanID } = useParams();
  const { data }: any = useLoaderData();
  const { fetchToken } = GetAuthContext();
  const { loanDetails, isMFL_LAP } = useOutletContext() as any;
  const token = fetchToken();

  return (
    <LoanTimelineTab
      pageName={pageName}
      isLenderPlatform={false}
      data={data}
      loanDetails={loanDetails}
      token={token}
      loanID={loanID}
      isMFL_LAP={isMFL_LAP}
    />
  );
}

export default LoanTimeline;
